export function initMobileMenu() {
    const menuElements = {
        menuTrigger: document.querySelectorAll('.header__menu-btn__trigger, .mobile-menu__menu-btn__trigger, .mobile-menu__overlay'),
        pagebody: document.querySelector('body'),
    };

    function toggleMenu() {
        menuElements.pagebody.classList.toggle('menu-active');
        menuElements.pagebody.classList.toggle('no-scroll');
    }

    function bindMenuOpen() {
        menuElements.menuTrigger.forEach(trigger => {
            trigger.addEventListener('click', function(event) {
                event.preventDefault();
                toggleMenu();
            });
        });
    }

    bindMenuOpen();



}
